export default __webpack_public_path__ + "static/media/edit-shape.f2d330cb.svg";